export const aboutData = {
  brandName: '最新发布页',
  brandIntro: '「最新发布页」诞生于对信息获取效率的极致追求。在信息爆炸的时代，我们深知用户面临的信息过载困境——重要信息被淹没在海量噪音中，真正有价值的内容难以被发现。因此，我们打造了这个一站式信息聚合平台，以最简洁高效的方式，将最有价值的内容呈现给每一位用户。',
  mission: '让每个人都能第一时间获取对自己有价值的信息。',
  vision: '成为中文互联网最值得信赖的信息聚合与分发平台。',
  foundedYear: '2022',
  stats: [
    { value: '50万+', label: '月活跃用户' },
    { value: '12万+', label: '累计发布内容' },
    { value: '99.9%', label: '服务可用率' },
    { value: '4.8/5', label: '用户满意度' },
  ],
  milestones: [
    { year: '2022年Q1', event: '平台正式上线，首批入驻100+内容合作伙伴' },
    { year: '2022年Q3', event: '月活跃用户突破10万，上线智能推荐引擎' },
    { year: '2023年Q1', event: '获得A轮融资，团队规模扩展至50人' },
    { year: '2023年Q4', event: '上线个性化定制功能，用户可自定义信息流' },
    { year: '2024年Q2', event: '月活跃用户突破30万，推出企业版服务' },
    { year: '2024年Q4', event: 'AI内容摘要功能上线，大幅提升信息获取效率' },
    { year: '2025年Q3', event: '实现盈利，累计服务用户超过100万' },
    { year: '2026年Q1', event: '全面升级平台架构，月活跃用户突破50万' },
  ],
  values: [
    { title: '信息质量', description: '严格的内容审核机制，确保每一条信息的真实性和价值' },
    { title: '用户体验', description: '简洁、高效、无障碍的信息获取体验是我们不懈的追求' },
    { title: '技术创新', description: '持续投入AI和数据处理技术，让信息分发更智能' },
    { title: '开放合作', description: '与优质内容创作者共建健康的内容生态' },
  ],
  contact: {
    email: 'contact@zuixinfabu.com',
    phone: '400-888-9999',
    address: '北京市海淀区中关村大街1号创新大厦18层',
    wechat: 'zuixinfabu2022',
  },
};